import { useMutation, useQueryClient } from "@tanstack/react-query"
import toast from "react-hot-toast";
import { updateProductPrice } from "services/apiProductPricing";

const useUpdateProductPricing = () => {
    const queryClient = useQueryClient();
    const{isPending:isUpdating,isSuccess:isUpdated,mutate: updatePrice} = useMutation({
        mutationFn: updateProductPrice,
        onSuccess:(data)=>{
            queryClient.setQueryData(['updatedPrice'],data)
            queryClient.invalidateQueries({queryKey:['priceList']})
            toast.success("Price Updated Successfully")
        },
        onError:(error)=>{
           console.log("Error occurred while adding products",error)
            if(error?.data && typeof error.data === "object"){
                for (const key in error.data){
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg)
                }
            }else{
                toast.error(error.message || 'Something went wrong')
            } 
        }
    })

    return{isUpdating,isUpdated,updatePrice}
}

export default useUpdateProductPricing
